// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CheckoutInfoState, initialCheckoutInfoState } from "@plumberssupply/App/Widgets/CheckoutStepper/StepperContext";

export interface CheckoutReducerAction {
    type: "update" | "reset";
    payload: CheckoutInfoState;
}

const checkoutReducer = (state: CheckoutInfoState, action: CheckoutReducerAction) => {
    switch (action.type) {
        case "update": {
            return { ...state, ...action.payload };
        }
        case "reset": {
            return { ...initialCheckoutInfoState };
        }
        default: {
            throw new Error(`Unhandled type: ${action.type}`);
        }
    }
};

export default checkoutReducer;
